<div class="min-h-[calc(100vh-4rem)] relative">
  <div
    [ngClass]="{
      'pr-0 transition-all duration-300': !sidebarOpen && !isResizing,
      'transition-all duration-200': sidebarOpen && !isResizing,
    }"
    [style.padding-right.px]="sidebarOpen ? sidebarWidth : 0"
  >
    <div class="px-6 py-4 font-medium relative min-h-[calc(100vh-4rem)]">
      <a class="text-amazone-orange hover:text-amazone-orange-hover ms-2" [routerLink]="['/dtc/overview']">
        ← Back to overview
      </a>
      <p class="text-amazone-green ms-2">
        Found <strong>{{ itemsTotalCount }} deactivated DTC's</strong>
      </p>
      <div class="relative">
        <app-dtc-table
          [recyclingModeEnabled]="recyclingModeEnabled"
          [dtcs]="items"
          [softDeleteDisabled]="swPartNumberIsReadOnly"
          [selectedElementId]="$safeNavigationMigration(selectedItem?.id)"
          (searchTriggered)="onSearchTriggered($event)"
          (softDeleteDtcTriggered)="onSoftDeleteTriggered($event)"
          (hardDeleteDtcTriggered)="onHardDeleteTriggered($event)"
          (restoreDtcTriggered)="onRestoreTriggered($event)"
          (downloadTriggered)="onDownloadTriggered()"
          (dtcClicked)="onItemClicked($event)"
          (scrolledToBottom)="onScrolledToTheBottom($event)"
          (sortByFieldChanged)="onSortByChanged($event)"
        ></app-dtc-table>
      </div>
    </div>
  </div>

  @if (sidebarOpen) {
    <div
      class="right-0 fixed overflow-y-auto border-l border-gray-200 min-h-full top-[4rem]"
      [style.width.px]="sidebarWidth"
    >
      <div
        class="absolute left-0 top-0 w-1.5 h-full cursor-col-resize bg-transparent hover:bg-amazone-green hover:opacity-50 transition-colors duration-200"
        (mousedown)="startResize($event)"
      ></div>
      <app-sidebar
        [dtc]="selectedItem"
        [sideBarTitle]="sideBarTitle"
        [detailsViewConfig]="dtcDetailConfiguration"
        [detailedLanguageTranslationStatesDocumentation]="
          $safeNavigationMigration(selectedItem?.languageTranslationStatesDocumentation)
        "
        [detailedLanguageTranslationStatesTerminal]="
          $safeNavigationMigration(selectedItem?.languageTranslationStatesTerminal)
        "
        [sidebarConfiguration]="sidebarConfiguration"
        (closeSidebarTriggered)="sidebarOpen = false"
      ></app-sidebar>
    </div>
  }
</div>
